<template>
  <div class="container mescroll-touch">
    <div class="borderTop"></div>
    <div class="liveInfo" v-if="liveDetails">
      <div class="liveCoverBox" v-if="liveDetails.Thumbnail" @click="tolive">
        <img class="liveCover" :src="liveDetails.Thumbnail" />
        <img class="playIcon" src="../../assets/images/play_icon.png" />
      </div>
      <p class="title">{{ liveDetails.Title }}</p>
      <div class="liveTimeBox">
        <img src="../../assets/images/live_detail_icon1.png" />
        <span>{{ liveDetails.StartTime | timeQuantum(liveDetails.EndTime) }}</span>
      </div>
      <!-- <div class="ForwardPosterBox">
        <img class="ForwardPosterBtn" @click="generatePoster" src="../../assets/images/ForwardPoster.png" />
        <img class="newGif" v-if="isNew" src="../../assets/images/newGif.gif" />
      </div> -->
      <div class="ForwardPosterBox" @click="generatePoster">
        <img class="relayIcon" src="../../assets/images/relay.png" />
        <span>转发</span>
        <img class="newGif" v-if="isNew" src="../../assets/images/newGif.gif" />
      </div>
    </div>
    <div class="speakerBox" v-if="liveDetails.SpeakerId">
      <div class="subjectTitle">
        <img src="../../assets/images/live_detail_icon2.png" />
        <span>专家阵容</span>
      </div>
      <div class="speakerFlexBox" @click="toPersonal(liveDetails.SpeakerId)">
        <div class="speakerIcon">
          <img src="@/assets/images/headSculpture1.png" alt="" />
        </div>
        <div class="speakerInfo">
          <div class="speakerInfo_top">
            <span class="speakerName">{{ liveDetails.Speaker }}</span>
            <span class="positionalName" v-if="liveDetails.SPositional">{{ liveDetails.SPositional }}</span>
          </div>
          <div class="speakerHospital">{{ liveDetails.SHospital }}</div>
        </div>
      </div>
    </div>
    <div class="liveIntroduceBox">
      <div class="subjectTitle">
        <img src="../../assets/images/live_detail_icon3.png" />
        <span>活动介绍</span>
      </div>
      <div class="liveIntroduce" v-if="liveDetails && liveDetails.ImageText" v-html="liveDetails.ImageText"></div>
    </div>
    <!-- <div class="evaluateBox">
      <div class="dztitle">欢迎您对本文打星评价</div>
      <div class="raterow">
        <div class="ratename">专业度</div>
        <van-rate v-model="rate1" :size="25" color="#EB1700" void-icon="star" void-color="#eee" gutter="13px" />
      </div>
      <div class="raterow">
        <div class="ratename">实用性</div>
        <van-rate v-model="rate2" :size="25" color="#EB1700" void-icon="star" void-color="#eee" gutter="13px" />
      </div>
      <div class="raterow">
        <div class="ratename">推荐度</div>
        <van-rate v-model="rate3" :size="25" color="#EB1700" void-icon="star" void-color="#eee" gutter="13px" />
      </div>
      <div class="rateupload" @click="submitArticleStars()">{{ rateId ? '修改评分' : '提交' }}</div>
    </div> -->
    <div class="commentBox">
      <div class="rowbtn">
        <span class="headline">评论</span>
        <div class="plbtn" @click="commentInputShow = true">评论</div>
      </div>
      <van-popup
        v-model="commentInputShow"
        closeable
        position="bottom"
        :style="{ height: '28%' }"
        class="plPopup"
      >
        <van-cell-group class="plinput">
          <van-field v-model="commentContent" type="textarea" rows="3" autosize placeholder="留言中不得出现任何违反法律法规，或侮辱，诽谤他人等侵害他人合法权益的内容。仅代表个人观点，与本公司无关，请对您发表的言论负责。" />
        </van-cell-group>
        <div class="rateupload" @click="submitComment">提交</div>
      </van-popup>

      <div class="plmain">
        <div class="plrow noComment" v-if="Object.keys(CommentList).length == 0">
          <img src="@/assets/images/none_comm@2x.png" />
          <span>暂无评论</span>
        </div>
        <div class="plrow" v-else v-for="(item, index) in CommentList" :key="index">
          <div class="pltop">
            <div class="plname">{{ item.CusRealName }}</div>
            <div class="pltime">{{ item.Time | dateFilter(item.Time) }}</div>
          </div>
          <div class="pltext">{{ item.Content }}</div>
          <div class="pldz">
            <img class="plicon" :src="item.LikeState ? require('@/assets/images/like_active.png') : require('@/assets/images/like.png')" @click="commentLikes(index, item.Id)"/>
            <span>{{ item.LikeCount }}</span>
          </div>
        </div>
      </div>
    </div>

    <div class="line"></div>

    <div class="relatedRecommendation">
      <div class="relatedTitle">
        <img class="icon" src="@/assets/images/related.png"/>
        <span>相关推荐</span>
      </div>
      <div class="relatedContent">
        <template v-if="recommendArticleList && recommendArticleList.length > 0">
          <div class="articleList" v-for="(item, index) in recommendArticleList" :key="index" @click="toContentPage(item.Id, item.Type)">
            <div class="articleCover">
              <img :src="item.Thumbnail" alt="" />
            </div>
            <div class="articleInfo">
              <p class="articleTitle van-multi-ellipsis--l2">{{ item.Title }}</p>
              <!-- <div class="articleData">
                <div class="operateBox">
                  <div class="operateItem">
                    <img class="operateIcon watch" src="@/assets/images/personal_watch_active.png" alt="" />
                    <span>{{ item.WatchCount }}</span>
                  </div>
                  <div class="operateItem">
                    <img class="operateIcon like" src="@/assets/images/personal_like_active.png" alt="" />
                    <span>{{ item.LikeCount }}</span>
                  </div>
                  <div class="operateItem">
                    <img class="operateIcon collect" src="@/assets/images/personal_collect_active.png" alt="" />
                    <span>{{ item.CollectCount }}</span>
                  </div>
                </div>
              </div> -->
            </div>
          </div>
        </template>
        <div class="noComment" v-else>
          <img src="@/assets/images/none_comm@2x.png" />
          <span>暂无相关推荐</span>
        </div>
      </div>
    </div>

    <div class="toTop" @click="toTop" v-show="!PosterShow">
      <img src="@/assets/images/top_comm_icon@2x.png" />
    </div>
    <div class="liveBtnBox">
      <div class="liveBtn reservationLive" v-if="!isReservation" @click="reservationLive">预约</div>
      <div class="liveBtn cancelReservationLive" v-else @click="reservationLive">取消预约</div>
      <div class="liveBtn enterLive" @click="tolive">进入活动</div>
    </div>
    <div class="bottombar">
      <div class="bottomrow" @click="goback">
        <div>
          <img class="bottomimg" src="@/assets/images/back.png" />
        </div>
        <div class="bottomtext">返回</div>
      </div>
      <div class="bottomrow" @click="handleLikes">
        <div>
          <img class="bottomimg" :src="isLikes ? require('@/assets/images/likesActive.png') : require('@/assets/images/likes.png')" />
        </div>
        <div class="bottomtext">点赞</div>
      </div>
      <!-- <div class="bottomrow" @click="generatePoster">
        <div>
          <img class="bottomimg" src="@/assets/images/share_ny_icon_nor@2x.png" />
        </div>
        <div class="bottomtext">海报转发</div>
      </div> -->
    </div>

    <!-- 海报转发 -->
    <van-popup class="PosterPopup" v-model="PosterShow" :close-on-click-overlay="false" @opened="generateImageOpened">
      <div class="close" @click="PosterShow = false">
        <van-icon class="closeIcon" name="cross" />
      </div>
      <div class="PosterBox">
        <div class="generateImageBox" ref="generateImageBox" v-if="!PosterPhoto">
          <img class="PosterImg" :src="imageUrls[0]" />
          <div class="QrcodeBox">
            <img class="QrcodeFont" src="@/assets/images/font1.png" />
            <img class="Qrcode" crossOrigin="anonymous" v-if="liveDetails.QRCode" :src="liveDetails.QRCode" />
            <img class="QrcodeFont" src="@/assets/images/font2.png" />
          </div>
        </div>
        <img class="PosterPhoto" v-else :src="PosterPhoto" alt="">
        <p class="tips">请长按保存图片到手机后转发</p>
      </div>
    </van-popup>

    <!-- 关注二维码弹窗 -->
    <van-popup class="FollowQRcodePopup" v-model="FollowQRcodePopup" overlay-class="FollowQRcodeOverlay" :close-on-click-overlay="false">
      <div class="FollowQRcodeBox">
        <div class="FollowQRcode">
          <img src="@/assets/images/qrcode.jpg" />
          <span>长按关注术韵公众号，开播提醒不迷路!</span>
        </div>
        <van-icon class="CloseFollowQRcode" name="close" @click="FollowQRcodePopup = false" />
      </div>
    </van-popup>

    <img class="gobackXG" v-if="$route.query.source == 'xg'" @click="toLiveHome" src="@/assets/images/gobackXG.png" />
  </div>
</template>

<script>
import wx from "weixin-js-sdk";
import html2canvas from 'html2canvas';
import { ImagePreview } from "vant";
import { mapState } from "vuex";

export default {
  name: 'LiveDetails',
  data() {
    return {
      timer: null,
      hasPath: '',
      liveDetails: {},
      recommendArticleList: [],
      rateId: '',
      rate1: 0,
      rate2: 0,
      rate3: 0,
      CommentList: [],
      commentInputShow: false,
      commentContent: '',
      isLikes: false,
      isReservation: false,
      isNew: false,
      imageUrls: [],
      PosterShow: false,
      PosterPhoto: '',
      FollowQRcodePopup: false, // 关注二维码弹窗
    }
  },
  computed: {
    ...mapState(["userInfo"]),
    id() {
      return this.$route.query.id;
    },
    sourceType() {
      return this.$route.query.sourceType
    },
    sourceId() {
      return this.$route.query.sourceId
    }
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.hasPath = from.path;
    });
  },
  created() {
    // this.getLiveDetails();
    this.getHandleState();
    this.getArticleStars();
    this.getRecommendArticle()
    this.getComment();
  },
  activated() {
    this.getLiveDetails();
    this.enter();
  },
  deactivated() {
    if (this.timer) {
      clearInterval(this.timer);
      this.timer = null;
    }
    
    if(this.liveLoading) {
      this.liveLoading.clear();
    }
  },
  beforeDestroy() {
    if (this.timer) {
      clearInterval(this.timer);
      this.timer = null;
    }
  },
  destroyed() {
    if (this.timer) {
      clearInterval(this.timer);
      this.timer = null;
    }

    if(this.liveLoading) {
      this.liveLoading.clear();
    }
  },
  methods: {
    timeline() {
      let d = new Date().getTime();
      this.$axios.post("/Api/Api/Web/BuriedPoint/AddDur", {
        ArticleId: this.id,
        Type: 1,
        Date: d
      }).then((res) => {
        if (!this.timer) {
          this.timer = setInterval(() => {
            let time = new Date().getTime();
            this.$axios.post("/Api/Api/Web/BuriedPoint/UpdateDur", {
              Id: res.Data,
              Date: time,
            });
          }, 10000);
        }
      });
    },
    enter() {
      this.$axios.post("/Api/Api/Web/Article/Handle", {
        ArticleId: parseInt(this.id),
        CustomerId: this.userInfo.Id,
        type: 1,
        Source: this.sourceType ? this.sourceType : 0,
        externalID: this.sourceId ? this.sourceId : ''
      }).then((res) => {
        if (!this.timer && res.Data != 0) {
          this.timer = setInterval(() => {
            this.$axios.post("/Api/Api/Web/Article/ABUpdateTime?id=" + res.Data).then(() => {});
          }, 10000);
        }
      });
    },
    getLiveDetails() {
      this.$axios.post("/Api/Api/Web/Article/GetArticleDetile?id=" + this.id).then((res) => {
        let data = res.Data;
        if(data.IsDeleted) {
          this.$router.replace('/noLive');
        } else {
          this.liveDetails = data;
          wx.miniProgram.postMessage({
            data: {
              share: {
                title: data.Title,
                imageUrl: '',
                path: `/pages/oneSurgery/oneSurgery?url=${encodeURIComponent(process.env.VUE_APP_BASE_URL + `/liveDetails?id=${this.id}&sourceType=7`)}`,
                contentId: this.id
              }
            }
          })
          // this.timeline();
        }
      })
    },
    getRecommendArticle() {
      this.$axios.post("/Api/Api/web/Article/GetArtDetile?id=" + this.id).then((res) => {
        this.recommendArticleList = res.Data.RecommendList;
      })
    },
    getArticleStars() {
      this.$axios.post("/Api/Api/Web/Article/GetArticleStars", {
        ArticleId: this.id,
        CustomerId: this.userInfo.Id
      }).then((res) => {
        let data = res.Data;
        if(data) {
          this.rateId = data.Id;
          this.rate1 = data.ProfessionalDegree / 20;
          this.rate2 = data.Practicability / 20;
          this.rate3 = data.RecommendationDegree / 20;
        }
      })
    },
    submitArticleStars() {
      let url = this.rateId ? '/Api/Api/Web/Article/UpdateArticleStars' : '/Api/Api/Web/Article/AddArticleStars';
      this.$axios.post(url, {
        ArticleId: this.id,
        CustomerId: this.userInfo.Id,
        ProfessionalDegree: this.rate1 * 20,
        Practicability: this.rate2 * 20,
        RecommendationDegree: this.rate3 * 20,
        id: this.rateId
      }).then((res) => {
        this.$dialog.alert({
          message: "提交成功！",
        }).then(() => {
          this.getArticleStars();
        });
      });
    },
    getComment() {
      this.$axios.post("/Api/Api/Web/Article/GetComment", {
        ArticleId: this.id,
        CustomerId: this.userInfo.Id
      }).then((res) => {
        this.CommentList = res.Data;
      });
    },
    submitComment() {
      if(this.commentContent) {
        this.$axios.post("/Api/Api/Web/Article/AddComment", {
          ArticleId: this.id,
          CustomerId: this.userInfo.Id,
          Content: this.commentContent,
          Type: 4
        }).then((res) => {
          if (res.RetCode == "10000") {
            this.$dialog.alert({
              message: "提交成功，审核通过后可以看到该评论",
            }).then(() => {
              this.commentInputShow = false;
              this.commentContent = '';
            });
          }
        });
      } else {
        this.$toast.fail('内容不能为空');
      }
    },
    commentLikes(index, id) {
      let url = this.CommentList[index].LikeState ? '/Api/Api/Web/Article/delCommentLike' : '/Api/Api/Web/Article/AddCommentLike';
      if(this.CommentList[index].LikeState) {
        this.CommentList[index].LikeCount--;
      } else {
        this.CommentList[index].LikeCount++;
      }
      this.CommentList[index].LikeState = !this.CommentList[index].LikeState;
      this.$axios.post(url, {
        CommentId: id,
        CustomerId: this.userInfo.Id
      }).then((res) => {
        // this.getComment();
      });
    },
    getHandleState() {
      this.$axios.post("/Api/Api/Web/Article/HandleState", {
        ArticleId: parseInt(this.id),
        CustomerId: this.userInfo.Id
      }).then((res) => {
        let data = res.Data;
        this.isLikes = data.some(item => item.type == 3);
        this.isReservation = data.some(item => item.type == 5);
        this.isNew = !data.some(item => item.type == 11);
      })
    },
    handleLikes() {
      let url = this.isLikes ? '/Api/Api/Web/Article/DelHandle' : '/Api/Api/Web/Article/Handle';
      this.isLikes = !this.isLikes;
      this.$axios.post(url, {
        ArticleId: parseInt(this.id),
        CustomerId: this.userInfo.Id,
        type: 3,
        Source: this.sourceType ? this.sourceType : 0,
        externalID: this.sourceId ? this.sourceId : ''
      }).then((res) => {
        // this.getHandleState();
      });
    },
    reservationLive() {
      let url = this.isReservation ? '/Api/Api/Web/Article/DelHandle' : '/Api/Api/Web/Article/Handle';
      this.isReservation = !this.isReservation;
      this.$axios.post(url, {
        ArticleId: parseInt(this.id),
        CustomerId: this.userInfo.Id,
        type: 5,
        Source: this.sourceType ? this.sourceType : 0,
        externalID: this.sourceId ? this.sourceId : ''
      }).then((res) => {
        this.getHandleState();

        if(url == '/Api/Api/Web/Article/Handle') {
          this.$axios.post('/Api/Api/Web/Customer/GetUserIsAttention').then((res) => {
            if(res.Data === 0) {
              this.FollowQRcodePopup = true;
            }
          });
        }
      });
    },
    tolive() {
      if(this.userInfo.Type == 3) {
        this.getLiveLink();
      } else if(this.liveDetails.IsCheck && this.liveDetails.UType == 1) {
        if(this.liveDetails.UserState == 1) {
          this.getLiveLink();
        } else {
          wx.miniProgram.navigateTo({url: '/pages/certificateNo2/certificateNo2'})
        }
      } else {
        this.getLiveLink();
      }
    },
    getLiveLink() {
      this.liveLoading = this.$toast.loading({
        message: '进入活动中...',
        forbidClick: true,
      });
      
      this.$axios.post("/Api/Api/Web/Article/Handle", {
        ArticleId: parseInt(this.id),
        CustomerId: this.userInfo.Id,
        Type: 9,
        Source: this.sourceType ? this.sourceType : 0,
        externalID: this.sourceId ? this.sourceId : ''
      }).then((res) => {});

      this.$axios.get("/Api/Api/Web/Live/LiveDocking?artId=" + this.id).then((res) => {
        window.location.href = res.Data;
      });
    },
    goback() {
      if(this.hasPath == '/' ) {
        this.$router.push('/liveList');
        return;
      }
      this.$router.go(-1);
    },
    generatePoster() {
      const parser = new DOMParser();
      const doc = parser.parseFromString(this.liveDetails.ImageText, 'text/html');
      const images = doc.querySelectorAll('img');
      const urls = Array.from(images).map(img => img.src);
      this.imageUrls = urls.length > 0 ? urls : [this.liveDetails.Thumbnail];
      this.PosterShow = true;
      this.$axios.post("/Api/Api/Web/Article/Handle", {
        ArticleId: parseInt(this.id),
        CustomerId: this.userInfo.Id,
        Type: 11,
        Source: this.sourceType ? this.sourceType : 0,
        externalID: this.sourceId ? this.sourceId : ''
      }).then((res) => {
        this.getHandleState();
      });
    },
    // generateImageOpened() {
    //   let toast = this.$toast.loading({
    //     message: '生成中...',
    //     forbidClick: true,
    //   });
    //   html2canvas(this.$refs.generateImageBox, {
    //     useCORS: true
    //   }).then((canvas) => {
    //     this.PosterPhoto = canvas.toDataURL("image/png");
    //     toast.clear();
    //   });
    // },
    generateImageOpened() {
      let toast = this.$toast.loading({
        message: '生成中...',
        forbidClick: true,
      });
      
      // 等待所有图片加载完成
      this.$nextTick(async () => {
        const images = this.$refs.generateImageBox.querySelectorAll('img');
        const imagePromises = Array.from(images).map(img => {
          return new Promise((resolve) => {
            if (img.complete && img.naturalHeight !== 0) {
              resolve();
            } else {
              img.onload = resolve;
              img.onerror = resolve; // 即使出错也继续
            }
          });
        });
        
        try {
          // 等待所有图片加载（或出错）
          await Promise.all(imagePromises);
          
          // 给一个延迟确保 DOM 稳定
          await new Promise(resolve => setTimeout(resolve, 500));
          
          html2canvas(this.$refs.generateImageBox, {
            useCORS: true,
            allowTaint: true, // 允许 tainted canvas
            backgroundColor: null, // 透明背景
            scale: 2, // 提高清晰度
          }).then((canvas) => {
            this.PosterPhoto = canvas.toDataURL("image/png");
            toast.clear();
          }).catch(error => {
            console.error('html2canvas 错误:', error);
            toast.clear();
            this.$toast('生成海报失败，请重试');
          });
          
        } catch (error) {
          toast.clear();
          console.error('图片等待错误:', error);
        }
      });
    },
    imagePreview(e) {
      if (e.target.nodeName == "IMG") {
        if(e.target.dataset.fileid) {
          this.videoPopupShow = true;
          this.getVideo(e.target.dataset.fileid);
        } else {
          ImagePreview({
            images: [e.target.currentSrc],
            maxZoom: 10,
            showIndex: false,
            loop: false,
          });
        }
      } else {
        return;
      }
    },
    toTop() {
      document.documentElement.scrollTop = document.body.scrollTop = 0;
    },
    toPersonal(id) {
      this.$router.push({
        path: 'Personal',
        query: {
          id: id
        }
      });
    },
    toLiveHome() {
      wx.miniProgram.navigateTo({url: '/pages/liveHome/liveHome'})
    },
    toContentPage(id, type) {
      if(type == 3) {
        this.$router.push({
          path: 'liveDetails',
          query: {
            id: id,
            sourceType: 6,
            sourceId: this.id
          }
        });
      } else {
        this.$router.push({
          path: 'contentPage',
          query: {
            id: id,
            type: type,
            sourceType: 6,
            sourceId: this.id
          }
        });
      }
    },
  }
}
</script>

<style lang="scss" scoped>
.container {
  min-height: 100%;
  padding-bottom: 8em;
  position: relative;
  -webkit-text-size-adjust: none;
  background-color: #F9F8F7;
  box-sizing: border-box;
  .borderTop {
    width: 100%;
    height: 10px;
    background-color: #EB1700;
  }
  .subjectTitle {
    display: flex;
    align-items: center;
    font-size: 15px;
    font-weight: bold;
    img {
      display: block;
      width: 20px;
      margin-right: 4px;
    }
    span {
      color: transparent; /* 使文字本身不可见 */
      background-image: linear-gradient(to right, #EB1700 40%, #C33BBB 60%, #8C3BBB 100%); /* 定义渐变颜色 */
      -webkit-background-clip: text; /* 针对WebKit浏览器 */
      background-clip: text; /* 使渐变仅应用于文字 */
    }
  }
  .liveInfo {
    position: relative;
    background-color: #FFFFFF;
    box-shadow: rgba(0, 0, 0, 0.1) 2px 2px 4px 0px;
    padding: 10px;
    border-radius: 8px;
    box-sizing: border-box;
    margin: 20px 15px;
    .liveCoverBox {
      position: relative;
      .liveCover {
        display: block;
        width: 100%;
      }
      .playIcon {
        position: absolute;
        top: 50%;
        left: 50%;
        width: 40px;
        transform: translate(-20px, -20px);
      }
    }
    .title {
      font-size: 16px;
      font-weight: bold;
      color: #564C47;
      line-height: 24px;
      margin: 13px 0 10px;
    }
    .liveTimeBox {
      display: flex;
      align-items: center;
      font-size: 15px;
      font-weight: bold;
      margin-bottom: 20px;
      img {
        display: block;
        width: 20px;
        margin-right: 4px;
      }
      span {
        color: transparent; /* 使文字本身不可见 */
        background-image: linear-gradient(to right, #EB1700 40%, #C33BBB 60%, #8C3BBB 100%); /* 定义渐变颜色 */
        -webkit-background-clip: text; /* 针对WebKit浏览器 */
        background-clip: text; /* 使渐变仅应用于文字 */
      }
    }
    .ForwardPosterBox {
      position: absolute;
      right: 0;
      bottom: 9px;
      display: flex;
      align-items: center;
      justify-content: center;
      width: 90px;
      height: 20px;
      line-height: 20px;
      font-size: 12px;
      color: #FFFFFF;
      background-color: #DB1F15;
      border-radius: 20px 0 0 20px;
      .relayIcon {
        display: block;
        width: 14px;
        margin-right: 4px;
      }
      .newGif {
        width: 30px;
        position: absolute;
        right: 0px;
        bottom: 17px;
      }
    }
  }
  .speakerBox {
    background-color: #FFFFFF;
    box-shadow: rgba(0, 0, 0, 0.1) 2px 2px 4px 0px;
    padding: 10px;
    border-radius: 8px;
    box-sizing: border-box;
    margin: 20px 15px;
    .speakerFlexBox {
      display: flex;
      margin: 15px auto 10px;
      color: #564C47;
      .speakerIcon {
        width: 50px;
        height: 50px;
        border-radius: 50%;
        box-shadow: rgba(0, 0, 0, 0.4) 0px 0px 4px 0px;
        margin-right: 12px;
        overflow: hidden;
        img {
          display: block;
          width: 100%;
        }
      }
      .speakerInfo {
        display: flex;
        flex-direction: column;
        justify-content: center;
        .speakerName {
          font-size: 16px;
          font-weight: bold;
        }
        .positionalName {
          font-size: 11px;
          background-color: #EAEAEA;
          padding: 1px 2px;
          margin-left: 10px;
        }
        .speakerHospital {
          font-size: 14px;
          margin-top: 5px;
        }
      }
    }
  }
  .liveIntroduceBox {
    position: relative;
    background-color: #FFFFFF;
    box-shadow: rgba(0, 0, 0, 0.1) 2px 2px 4px 0px;
    padding: 10px;
    border-radius: 8px;
    box-sizing: border-box;
    margin: 20px 15px;
    .liveIntroduce {
      margin-top: 10px;
    }
    /deep/ .liveIntroduce img {
      display: block;
      width: 100%;
    }
    /deep/ .VContent > p > img {
      width: 100%;
    }
  }
  .evaluateBox {
    position: relative;
    background-color: #FFFFFF;
    box-shadow: rgba(0, 0, 0, 0.1) 2px 2px 4px 0px;
    padding: 1em;
    border-radius: 8px;
    box-sizing: border-box;
    margin: 20px 15px;
    .dztitle {
      text-align: center;
      margin-bottom: 20px;
    }
    .ratename {
      display: inline-block;
      margin-right: 2em;
      vertical-align: middle;
      font-size: 15px;
      color: #606060;
    }
    .raterow {
      text-align: center;
      margin-bottom: 0.8em;
    }
    .van-rate {
      vertical-align: middle;
    }
    .rateupload {
      border: 0;
      width: 100px;
      height: 36px;
      line-height: 36px;
      border-radius: 36px;
      text-align: center;
      margin: 20px auto 0;
      background-image: url('../../assets/images/btn_bg1.png');
      background-size: 100% 100%;
      font-size: 14px;
      color: #FFFFFF;
    }
  }
  .commentBox {
    margin: 20px 15px;
    .rowbtn {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin: 20px auto;
      color: #CA001A;
      .headline {
        font-size: 16px;
        font-weight: bold;
      }
    }
    .plbtn {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 100px;
      height: 22px;
      line-height: 22px;
      color: #CA001B;
      font-size: 14px;
      font-weight: bold;
      background-image: url('../../assets/images/comment_bg.png');
      background-size: 100% 100%;
      padding-left: 16px;
      box-sizing: border-box;
    }
    .plPopup {
      padding-top: 3em;
    }
    .plinput {
      margin: auto;
      margin-bottom: 2em;
      width: 90%;
      border: 1px solid #CA001B;
      border-radius: 10px;
      overflow: hidden;
      margin-top: 1em;
    }
    .rateupload {
      border: 0;
      width: 100px;
      height: 36px;
      line-height: 36px;
      border-radius: 36px;
      text-align: center;
      margin: 20px auto 0;
      background-image: url('../../assets/images/btn_bg1.png');
      background-size: 100% 100%;
      font-size: 14px;
      color: #FFFFFF;
    }
    .plmain {
      width: 90%;
      margin: auto;
      margin-bottom: 2em;
    }
    .plrow {
      position: relative;
      margin-bottom: 1em;
    }
    .tx {
      display: inline-block;
      width: 28px;
      height: 28px;
      border-radius: 50%;
      overflow: hidden;
      vertical-align: middle;
      img {
        width: 100%;
        display: block;
      }
    }
    .plname {
      display: inline-block;
      font-size: 14px;
      margin-left: 0.5em;
      color: #999999;
    }
    .pltop {
      position: relative;
    }
    .pltime {
      position: absolute;
      right: 0;
      font-size: 12px;
      top: 22%;
      color: #999999;
    }
    .pltext {
      font-size: 14px;
      color: #333333;
      padding-left: 34px;
    }
    .pldz {
      margin-left: 34px;
      display: flex;
      justify-content: flex-end;
      align-items: center;
      border-bottom: 1px solid #EEEEEE;
      padding-bottom: 12px;
      img {
        width: 14px;
        height: 14px;
      }
      span {
        margin-left: 4px;
        color: #333333;
        font-size: 12px;
      }
    }
    .noComment {
      text-align: center;
      img {
        width: 180px;
        margin-bottom: 20px;
      }
      span {
        display: block;
        font-size: 12px;
        color: #CCCCCC;
      }
    }
  }
  .toTop {
    position: fixed;
    right: 13px;
    bottom: 72px;
    width: 40px;
    height: 40px;
    text-align: center;
    padding-bottom: 1.5em;
    padding-top: 0.5em;
    z-index: 999;
    img {
      width: 100%;
      height: 100%;
    }
  }
  .liveBtnBox {
    width: 100%;
    position: fixed;
    bottom: 95px;
    display: flex;
    justify-content: space-between;
    padding: 0 70px;
    box-sizing: border-box;
    z-index: 0;
    .liveBtn {
      width: 40%;
      height: 35px;
      line-height: 35px;
      border-radius: 35px;
      text-align: center;
      font-size: 14px;
      font-weight: bold;
    }
    .reservationLive {
      color: #FFFFFF;
      background-image: url('../../assets/images/btn_bg1.png');
      background-size: 100% 100%;
    }
    .cancelReservationLive {
      color: #CA001A;
      background-image: url('../../assets/images/btn_bg2.png');
      background-size: 100% 100%;
    }
    .enterLive {
      color: #FFFFFF;
      background-image: url('../../assets/images/btn_bg1.png');
      background-size: 100% 100%;
    }
  }
  .bottombar {
    position: fixed;
    bottom: 0;
    background: #fff;
    width: 100%;
    text-align: center;
    padding-bottom: 1.5em;
    padding-top: 0.5em;
    box-shadow: rgba(0, 0, 0, 0.1) 2px 2px 4px 0px;
    z-index: 99;
    .bottomrow {
      display: inline-block;
      width: 30%;
    }
    .bottomimg {
      width: 1.5em;
    }
    .bottomtext {
      font-weight: bold;
      color: #564C47;
      font-size: 14px
    }
  }
}
.PosterPopup {
  width: 90%;
  height: 350px;
  border-radius: 14px;
  overflow-y: visible;
}
.close {
  position: absolute;
  top: -7px;
  right: -7px;
  width: 20px;
  height: 20px;
  line-height: 20px;
  text-align: center;
  border-radius: 50%;
  background-image: linear-gradient(130deg, #EB1700 50%, #C33BBB 80%, #8C3BBB 100%);
  z-index: 99;
  .closeIcon {
    color: #FFFFFF;
  }
}
.PosterBox {
  position: relative;
  width: 100%;
  height: 100%;
  overflow-y: auto;
  border-radius: 14px;
  .generateImageBox {
    padding-bottom: 10px;
  }
  .PosterImg {
    display: block;
    width: 100%;
  }
  .QrcodeBox {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 10px;
    .QrcodeFont {
      width: 60px;
    }
  }
  .Qrcode {
    display: block;
    width: 100px;
    margin: 0 30px ;
  }
  .PosterPhoto {
    display: block;
    width: 100%;
  }
  .tips {
    font-size: 13px;
    color: #333333;
    margin: 0 0 18px;
  }
}
.FollowQRcodePopup {
  width: 100%;
  height: 100%;
  background-color: transparent;
  .FollowQRcodeBox {
    width: 100%;
    height: 100%;
    text-align: center;
    .FollowQRcode {
      position: relative;
      top: 20%;
      left: 10%;
      width: 80%;
      background-color: #FFFFFF;
      padding: 30px 20px;
      box-sizing: border-box;
      font-size: 14px;
      color: #4A4A4A;
      font-weight: bold;
      text-align: center;
      border-radius: 12px;
      img {
        display: block;
        width: 75%;
        margin: 0 auto 10px;
      }
    }
    .CloseFollowQRcode {
      margin-top: 48%;
      font-size: 26px;
      color: #FFFFFF;
      opacity: 0.8;
    }
  }
}
.gobackXG {
  position: fixed;
  right: 2px;
  bottom: 200px;
  width: 72px;
}
.line {
  width: 90%;
  height: 2px;
  border-radius: 2px;
  margin: 0 auto;
  background-image: url('../../assets/images/bg_comm_png@2x.png');
  background-repeat: no-repeat;
  background-size: 100% 100%;
}
.noComment {
  text-align: center;
  img {
    width: 180px;
    margin-bottom: 20px;
  }
  span {
    display: block;
    font-size: 12px;
    color: #CCCCCC;
  }
}
.relatedRecommendation {
  width: 90%;
  margin: 0 auto 30px;
  .relatedTitle {
    display: flex;
    align-items: center;
    font-size: 16px;
    font-weight: bold;
    color: #CA001A;
    padding: 10px 0;
    .icon {
      display: block;
      width: 15px;
      margin-right: 4px;
    }
  }
  .relatedContent {
    background-color: #FFFFFF;
    box-shadow: rgba(0, 0, 0, 0.1) 2px 2px 4px 0px;
    border-radius: 8px;
    padding: 10px 6px;
    box-sizing: border-box;
    margin-bottom: 10px;
    .articleList {
      display: flex;
      .articleCover {
        position: relative;
        width: 40%;
        border-radius: 6px;
        overflow: hidden;
        img {
          display: block;
          width: 100%;
        }
        .sourceTag {
          position: absolute;
          top: 0;
          left: 0;
          min-width: 50px;
          height: 16px;
          line-height: 16px;
          text-align: center;
          font-size: 8px;
          color: #FFFFFF;
          background-image: linear-gradient(to right, #EB1700 0%, #C33BBB 50%, #8C3BBB 100%);
          border-radius: 0 0 8px 0;
          padding: 0 4px;
          box-sizing: border-box;
        }
      }
      .articleInfo {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        width: 60%;
        padding-left: 8px;
        box-sizing: border-box;
        color: #564C47;
        .articleTitle {
          font-size: 14px;
          line-height: 18px;
        }
        .articleData {
          .operateBox {
            display: flex;
            justify-content: flex-end;
            align-items: center;
          }
          .operateItem {
            display: flex;
            align-items: center;
            font-size: 12px;
            margin-left: 10px;
          }
          .operateIcon {
            display: block;
            width: 12px;
            margin-right: 2px;
          }
          .watch {
            width: 13px;
          }
          .like {
            width: 11px;
          }
          .collect {
            width: 11px;
          }
        }
      }
    }
    .articleList:not(:last-of-type) {
      margin-bottom: 10px;
    }
  }
}
</style>
